/**
 * Kategorie eines individuellen Inputs
 * (bestimmt den Bereich in dem der Input eingefügt wird)
 */
export enum CustomInputCategory {
   /**
    * Standardkategorie, wenn keine spezielle Kategorie benötigt wird.
    */
   default = "default",

   /**
    * Allegmein zum jeweiligen Formular
    */
   general = "general",

   /**
    * Haupt-Kontakt Informationen
    */
   contact = "contact",

   /**
    * Kontakt der Teilnehmenden Informationen
    */
   participant = "participant",

   /**
    * Zahlungsinformationen
    */
   payment = "payment",

   /**
    * Einwilligungen
    */
   aprovel = "aprovel",
}

export const CustomInputCategoryNames = {
   general: "Allgemein",
   contact: "Haupt-Kontakt",
   participant: "Kontakt (Teilnehmende)",
   payment: "Zahlungsmittel",
   aprovel: "Einwilligungen"
};